import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, CalendarClock } from "lucide-react";

export default function Tarifs() {
  useEffect(() => {
    document.title = "Nos Tarifs — NBPerf";
    return () => {
      document.title = "NBPerf — Reprogrammation moteur E85 & diesel";
    };
  }, []);

  return (
    <main className="pt-16" data-testid="tarifs-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-8 py-16 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center"
        >
          <p className="font-script text-2xl text-[#6EB000] mb-2">La fiche officielle, sans détour</p>
          <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl text-white" data-testid="tarifs-title">
            Nos <span className="text-[#6EB000]">tarifs</span> NBPerf
          </h1>
          <p className="text-white/60 mt-4 text-sm sm:text-base" data-testid="tarifs-subtitle">
            Reprogrammation moteur • FlexFuel E85 • Options • Diagnostic &amp; Services
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-12"
        >
          <img
            src="/tarifs-nbperf.png"
            alt="Fiche tarifaire officielle NBPerf — stages de reprogrammation, packs préparation moteur Stage 2 et 3, FlexFuel E85, options cumulables, diagnostic et services"
            className="w-full h-auto border border-[#454C50] shadow-[0_20px_60px_rgba(0,0,0,0.45)]"
            data-testid="tarifs-image"
          />
        </motion.div>

        <p className="text-center text-xs text-white/40 mt-6 max-w-2xl mx-auto" data-testid="tarifs-note">
          Prix indicatifs NBPerf — toute intervention fait l'objet d'une étude préalable de votre véhicule.
          Moyens de paiement : PayPal, carte bancaire, paiement en plusieurs fois disponible via PayPal sous réserve d'éligibilité, espèces sur place.
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link
            to="/configurateur"
            className="clip-angle inline-flex items-center gap-2 bg-[#6EB000] text-black font-bold px-8 py-4 text-sm uppercase tracking-widest hover:bg-[#5A9000] active:scale-95 transition-all duration-200"
            data-testid="tarifs-cta-devis"
          >
            Composer ma prestation
            <ArrowUpRight className="w-4 h-4" />
          </Link>
          <Link
            to="/reservation"
            className="clip-angle inline-flex items-center gap-2 border border-[#6EB000] text-[#6EB000] px-8 py-4 text-sm uppercase tracking-widest hover:bg-[#6EB000]/10 transition-colors"
            data-testid="tarifs-cta-resa"
          >
            <CalendarClock className="w-4 h-4" />
            Réserver un créneau
          </Link>
        </div>
      </div>
    </main>
  );
}
